var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5124 8.99806L26.0133 9.01844L22.6213 0.416504H0.666016V50.4165H37.4801V15.2755L26.5124 8.99806Z",
    fill: "#F8F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4793 15.2755L26.5116 8.99806L26.0125 9.01844L22.6205 0.416504H19.0723V50.4165H37.4793V15.2755Z",
    fill: "#E9EDF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93945 21.436V25.5511H12.5221L14.0705 21.436H3.93945Z",
    fill: "#DCE1EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7617 25.5511H19.3453L19.0714 24.7422L18.7617 25.5511Z",
    fill: "#DCE1EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0723 24.7422V25.5511H19.3462L19.0723 24.7422Z",
    fill: "#BEC3D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2056 25.5511V21.436H24.043L25.5977 25.5511H34.2056Z",
    fill: "#BEC3D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9863 33.7506H22.1232L20.845 29.9761H17.2645L15.9863 33.7506Z",
    fill: "#DCE1EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8447 29.9761H19.0723V33.7506H22.1228L20.8447 29.9761Z",
    fill: "#BEC3D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2057 34.0912V29.9761H27.2695L28.8242 34.0912H34.2057Z",
    fill: "#BEC3D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93945 29.9761V34.0912H9.30841L10.857 29.9761H3.93945Z",
    fill: "#DCE1EB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3261 39.165L13.1348 42.6305H25.0114L23.8201 39.165H14.3261Z",
    fill: "#DCE1EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8195 39.165H19.0723V42.6305H25.0107L23.8195 39.165Z",
    fill: "#BEC3D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93945 38.5161V42.6311H6.09486L7.6433 38.5161H3.93945Z",
    fill: "#DCE1EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2058 42.6311V38.5161H30.4961L32.0508 42.6311H34.2058Z",
    fill: "#BEC3D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8236 34.0908H19.0723V38.5156H30.4954L28.8236 34.0908Z",
    fill: "#FF583E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9531 18.5527H19.0723V21.4361H24.0425L22.9531 18.5527Z",
    fill: "#FF583E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5972 25.5511L24.0425 21.436H19.0723V24.7422L19.3462 25.5511H25.5972Z",
    fill: "#FF432E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2689 29.9761H20.8447L22.1228 33.7506H19.0723V34.0912H28.8236L27.2689 29.9761Z",
    fill: "#FF432E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.042 21.436L25.5967 25.5513L27.2676 29.9761H27.2686L28.8232 34.0913L30.4941 38.5161L32.0488 42.6313H25.0098L23.8184 39.1655H14.3242L13.1328 42.6313H6.09375L7.64258 38.5161L9.30762 34.0913L10.8564 29.9761L12.5215 25.5513L14.0693 21.436L15.1553 18.5522H22.9521L24.042 21.436ZM18.7617 25.5513L17.2637 29.9761L15.9854 33.7505H22.1221L20.8438 29.9761L19.3457 25.5513L19.0713 24.7417L18.7617 25.5513Z",
    fill: "url(#paint0_linear_328_2521)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_2521",
    x1: 19.0713,
    y1: 42.6313,
    x2: 19.0713,
    y2: 18.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermark);
export default __webpack_public_path__ + "static/media/watermark.1f231796ff1ddadaf95c80ebe640b524.svg";
export { ForwardRef as ReactComponent };